import React from "react";
import TempleTimingsInfo from "./TempleTimingsInfo";

function Timing() {
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/darsan.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            
            <div className="container" style={{ backgroundImage: 'url(./images/event.jpeg)', marginTop: '100px', marginBottom: '100px', padding: '50px', backgroundSize: 'cover', backgroundAttachment: 'fixed',borderRadius:'25px',boxShadow:'0px 0px 1000px maroon ',display:'flex',justifyContent:'center',alignItems:'center' }}>
                    <TempleTimingsInfo />
                {/* ----- Start normal darsan time ----- */}
                {/* <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'10px',paddingBottom:'15px',paddingTop:'15px'}}>
                    
                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li>
                                <li className="timelist">After 12:00</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                <li className="timelist">4:30 PM to 6:15 PM</li>
                                <li className="timelist">6:45 PM to 7:20 PM</li>
                                <li className="timelist">After Sreeveli</li>
                                </ul>
                      </div>
                    </div>
                     
                </div>
                
                
           </div> 
                      
        </div> */}

                {/* ----- end normal darsan time ----- */}

                    {/* <div className="row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',marginBottom:'40px'  }}>
                    <div className="col-md-7" style={{ background: '#ffeccaf6', padding: '50px',borderRadius:'20px' }}>
                        <div className="row" style={{ marginBottom: '50px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px', background: 'orange' }}>
                            <div className="col-md-12 middle">
                                <center><p className="enquiry">Darsan Timing from 01-01-2026 to 08-01-2026</p> </center>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '15px' }}>
                           

                            <div class="row col-md-12">
                                <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Morning</h3>
                                    <ul>
                                        <li className="timelist">03:30 AM to 04:45 AM</li>
                                        <li className="timelist">06:30 AM to 7:00 AM</li>
                                        <li className="timelist">09:30 AM to 11:15 AM</li>
                                        <li className="timelist">12:00 PM to 01:00 PM</li>
                                    </ul>
                                </div>
                                
                                 <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Evening</h3>
                                    <ul>
                                        <li className="timelist">04:30 PM to 06:15 PM </li>
                                        <li className="timelist">06:45 PM to 07:20 PM </li>
                                        <li className="timelist">After Sheeveli</li>
                                    </ul>
                                </div>
                                
                            </div>
                            
                        </div>


                    </div>

                </div> */}

                
                {/* <div className="row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',marginBottom:'20px' }}>
                    <div className="col-md-7" style={{ background: '#ffeccaf6', padding: '50px',borderRadius:'20px'  }}>
                        <div className="row" style={{ marginBottom: '50px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px', background: 'orange' }}>
                            <div className="col-md-12 middle">
                                <center><p className="enquiry">സ്വർഗ്ഗ വാതിൽ ഏകാദശി - 31-12-2025</p> </center>
                            </div>
                        </div>
                        <div className="row" style={{  paddingTop: '15px' }}>
                           

                            <div class="row col-md-12">
                                <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Morning</h3>
                                    <ul>
                                        <li className="timelist">2:30 AM to 03:45 AM - (നിർമാല്യം, അഭിഷേകം, ദീപാരാധന)</li>
                                        <li className="timelist">4:00 AM to 6:00 AM</li>
                                        <li className="timelist">09:45 AM to 11:30 AM</li>
                                        <li className="timelist">12:00 AM to 01:00 PM</li>
                                    </ul>
                                </div>
                                <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Afternoon</h3>
                                    <ul>
                                        <li className="timelist">12:00 PM to 01:00 PM </li>
                                    </ul>
                                </div>
                                 <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Evening</h3>
                                    <ul>
                                        <li className="timelist">03:30 PM to 06:00 PM </li>
                                    </ul>
                                </div>
                                <div className="col-md-6 " style={{ padding: '10px' }}>
                                    <h3 className="heading">Night</h3>
                                    <ul>
                                        <li className="timelist">രാത്രി ഏകാദശി ശീവേലി 08:15 PM</li>
                                        <li className="timelist">രാത്രി 09:15 കഴിഞ്ഞ് ദർശനം ഉണ്ടായിരിക്കുന്നതാണ്.</li>
                                    </ul>
                                </div>
                            </div>
                            <h5 style={{marginTop:'25px',fontWeight:'700',fontSize:'15pt'}}>Entry into the Temple from outside will be permitted only upto 9:00 pm</h5>
                        </div>


                    </div>

                </div> */}

            </div>
        </div>
    );
}

export default Timing;